// extracted by mini-css-extract-plugin
export default {"bell":"NotificationBell_bell__LvI5-","badge":"NotificationBell_badge__x-xVZ"};